/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    color: PropTypes.oneOf(['primary', 'secondary']),
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'primary',
};

const Progress = (props) => {
    const classNames = [
        'c-progress',
        `c-progress--${props.color}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Progress.propTypes = propTypes;

Progress.defaultProps = defaultProps;

export default Progress;
